export enum DATE {
    YMD = 'YYYY-MM-DD',
}

export const dateCommon = 'YYYY-MM-DD'
